import i18n from '@/utils/translations/i18n';
import { REGEX } from '@/utils/validator';
import * as yup from 'yup';

const fieldsValidate = {
  username: yup
    .string()
    .matches(REGEX.username, i18n.t('validate.username.messageValidate'))
    .required(i18n.t('validate.username.messageRequire')),
  password: yup
    .string()
    .matches(REGEX.password, i18n.t('validate.password.messageValidate'))
    .required(i18n.t('validate.password.messageRequire')),
  //   repeatPassword: yup
  //     .string()
  //     .oneOf(
  //       [yup.ref('password')],
  //       i18n.t('validate.password.repeat.messageValidate')
  //     )
  //     .required(i18n.t('validate.password.repeat.messageRequire')),
};

export default fieldsValidate;
